import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ref-order p-d-flex p-ai-center" }
const _hoisted_2 = { class: "ref-order-images" }
const _hoisted_3 = { class: "ref-order-details" }
const _hoisted_4 = { class: "ref-order-title" }
const _hoisted_5 = { class: "ref-order-description" }
const _hoisted_6 = { class: "ref-order-price" }
const _hoisted_7 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_p_divider = _resolveComponent("p-divider")!
  const _directive_app_fast_gallery = _resolveDirective("app-fast-gallery")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
    return (_openBlock(), _createElementBlock("div", {
      key: order.id,
      class: "ref-orders-list-item"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
          [_directive_app_fast_gallery, { images: _ctx.images(order) }]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(order.title), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.description, (desc, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(desc), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("strong", _hoisted_7, [
              (!_ctx.isOrderWithTBD(order))
                ? (_openBlock(), _createBlock(_component_app_format_currency, {
                    key: 0,
                    value: order?.total_price,
                    currency: order?.currency
                  }, null, 8, ["value", "currency"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("TBD")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createVNode(_component_p_divider, { class: "p-m-0" })
    ]))
  }), 128))
}